import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Format } from '../../types/format.types';

@Component({
  selector: 'app-text-field-badge',
  templateUrl: 'text-field-badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFieldBadgeComponent {
  @Input()
  public config: Format.ITextFieldConfig;
}
